/**
 * Conditionally wraps React children with another component.
 * @param {Object} props The component props.
 * @returns {JSX}
 */var ConditionalWrapper=function ConditionalWrapper(_ref){var condition=_ref.condition,wrapper=_ref.wrapper,children=_ref.children;return condition?wrapper(children):children;};export default ConditionalWrapper;